// extracted by mini-css-extract-plugin
export default {"title":"SellerWebsiteLink-module-title","link":"SellerWebsiteLink-module-link"};